<!-- [variant]="'on'" -->
<p-floatlabel class="flex grow">
    <p-inputnumber
        #inputNumber
        class="{{ inputClassStyle() }}"
        [inputStyle]="inputStyle()"
        [inputStyleClass]="inputClassStyle()"
        [styleClass]="inputClassStyle()"
        id="{{ id() }}"
        autocomplete="{{ autocomplete() }}"
        mode="{{ mode() }}"
        [minFractionDigits]="minFractionDigits()"
        [maxFractionDigits]="maxFractionDigits()"
        [min]="min()"
        [max]="max()"
        [step]="step()"
        [locale]="locale()"
        [suffix]="suffix()"
        [ngModel]="model"
        (onKeyDown)="onKeyDown($event)"
        (ngModelChange)="onModelValueChange($event)"
        [ngModelOptions]="{ standalone: true }"
    ></p-inputnumber>

    <label for="{{ id() }}" class="{{ labelClassStyle() }}">{{
        label()
    }}</label>
</p-floatlabel>
